import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';

const makeImageUrl = (cdnUrl, name) => `${cdnUrl}g/ftg_logos/store_${name}.png`;

const CdnImage = ({ name, alt }) => {
  const { market = { imageCdnUrl: '', code: '' } } = useContext(AppContext);
  return (
    <picture alt={alt}>
      {/* <source
        srcSet={makeImageUrl(
          market.imageCdnUrl,
          market.code,
          type,
          name,
          width,
          'webp'
        )}
        type="image/webp"
      /> */}
      {/* Safari fallback */}
      <source
        srcSet={makeImageUrl(market.imageCdnUrl, name)}
        type="image/png"
      />
      {/* IE fallback */}
      <img src={makeImageUrl(market.imageCdnUrl, name)} alt={alt} />
    </picture>
  );
};

export const cdnImageTypes = {
  store: 'store',
};

const { string, number, oneOf, oneOfType } = PropTypes;

CdnImage.propTypes = {
  type: oneOf(Object.values(cdnImageTypes)).isRequired,
  name: oneOfType([string, number]).isRequired,
  width: number.isRequired,
  alt: string,
};

CdnImage.defaultProps = {
  alt: undefined,
};

export default memo(CdnImage);
